module.exports = __webpack_public_path__ + "static/gratuk-icon-b9c978f4447b4da26e54c668dddbc618.jpg";